import React from 'react';
import Main from '../Main';


const ViewKpiModal = ({
    name,
    showKpiModal,
    setShowKpiModal,

}) => {
    if (!showKpiModal) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
            <div className="bg-white rounded-lg shadow-xl w-4/5 h-[90vh] overflow-hidden">
                {/* Modal Header */}
                <div className="flex items-center justify-between p-4 border-b border-gray-200">
                    <div>
                        <h2 className="text-2xl font-bold text-black">Report Analysis</h2>
                    </div>
                    <button
                        onClick={() => {
                            setShowKpiModal(false);
                        }}
                        className="text-black hover:text-gray-600 transition-colors p-2 hover:bg-gray-100 rounded-full"
                        title="Close"
                    >
                        <svg
                            className="h-6"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M6 18L18 6M6 6l12 12"
                            />
                        </svg>
                    </button>
                </div>

                {/* Modal Body */}
                <div className="px-2 py-2  overflow-y-auto h-auto bg-[#dadce5] ">

                    <Main productName={name} />

                </div>
            </div>
        </div>
    );
};

export default ViewKpiModal;


